import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  members: [],
  currentMember: null,
  beneficiaries: [],
  isLoading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
  },
};

const memberSlice = createSlice({
  name: 'member',
  initialState,
  reducers: {
    fetchMembersStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchMembersSuccess: (state, action) => {
      state.isLoading = false;
      state.members = action.payload.data || action.payload;
      if (action.payload.pagination) {
        state.pagination = action.payload.pagination;
      }
    },
    fetchMembersFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setCurrentMember: (state, action) => {
      state.currentMember = action.payload;
    },
    clearCurrentMember: (state) => {
      state.currentMember = null;
    },
    setBeneficiaries: (state, action) => {
      state.beneficiaries = action.payload;
    },
    updateMemberStatus: (state, action) => {
      const { id, status } = action.payload;
      const member = state.members.find(m => m.id === id);
      if (member) member.status = status;
      if (state.currentMember?.id === id) state.currentMember.status = status;
    },
  },
});

export const {
  fetchMembersStart,
  fetchMembersSuccess,
  fetchMembersFailure,
  setCurrentMember,
  clearCurrentMember,
  setBeneficiaries,
  updateMemberStatus,
} = memberSlice.actions;

export default memberSlice.reducer;